/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect } from "react";
import gameImg from "assets/img/ball.jpg";
import { useHistory } from 'react-router-dom';
// import PlayerList from './PlayerList.js';
import { Input } from "reactstrap";

// reactstrap components
import {  
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Form,
  Row,
  Col,
} from "reactstrap";

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";

var aTimeout = null;

function BigGoalsetting(props) {
  
  const [goalsetting, s_setGoalsetting] = useState([]);
  const [playerIndex, setPlayerIndex] = useState(0);
  
  const history = useHistory();

  const getViewpageUrl = (tmp) => {

    window.sessionStorage.setItem('target', JSON.stringify(tmp)); 
    history.push('../coach/biggoalsettingedit');

  };
  
  useEffect(() => {    

    let session = window.sessionStorage.getItem('player'); 
    let se = JSON.parse(session);
    if(!se){
      return;
    }
       
    //サーブ

    axios.get(URL_API+"getBigSettingAPI", {
      params: {
        sel: se['id'], 
      }
    })
    .then(function (response) {

      if(Array.isArray(response.data)){
        s_setGoalsetting(response.data);
      }

    }); 
       

  }, []);
  
  return (
    <>
        <Col className="col-12 mt-2">                                         
          {
            goalsetting?.map((tmp, index) => 

            <Row className="align-items-center" key={index} onClick={() => getViewpageUrl(tmp)} val={tmp.id}> 
              <Col className="col-2" style={{color:'rgb(36 160 216)', fontSize:'16px', paddingRight:'0px', textAlign: 'center'}}>
                <img src={gameImg}  width="50px"/>
              </Col>                        
              <Col className="col-6" style={{color:'rgb(36 160 216)', fontSize:'16px', display: 'flex', alignItems: 'center', wordBreak: 'break-all'}}>
                <b>{tmp.target1}</b>
              </Col>
              <Col className="col-4" style={{color:'rgb(36 160 216)', fontSize:'16px', display: 'flex', alignItems: 'center'}}>                          
                {tmp.edit_date}
              </Col>
            </Row>
            )
          } 
        </Col> 
    </>
  );
}
export default BigGoalsetting;